var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","disabled":_vm.disabled,"title":"Администрирование","href":"/tourclient/admin/admin/"}},[_c('v-icon',{domProps:{"textContent":_vm._s('mdi-cog')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }